module.exports = __webpack_public_path__ + "img/icon_3_17.7e29b42f.png";